import React, { useEffect, useState, createContext, useContext, useRef } from 'react';
import pako from 'pako';
import axios from 'axios';
import HelmetProvider from '/src/Components/HelmetProvider/HelmetProvider';

import './PropertyExplorer.css';
import { useNavigate, useParams } from 'react-router-dom';

// IMPORT THE WINDOW SIZE CONTEXT and AddressSearchContext
import { WindowSizeContext, TestStatusContext, AddressSearchContext } from '/src/App';

// IMPORT THE SECTIONS
// import About from './About/About';
// import AreasThreatened from './AreasThreatened/AreasThreatened';
// import Budgeting from './FinancialProjections/Sections/Budgeting/Budgeting';
// import Checklist from './Checklist/Checklist';
// import ClimateRisks from './ClimateRisks/ClimateRisks';
// import HowAnalysisBuilt from './HowAnalysisBuilt/HowAnalysisBuilt';
// import LTV from './FinancialProjections/Sections/LTV/LTV';
// import Opex from './FinancialProjections/Sections/Opex/Opex';
// import RecommendedProjects from './RecommendedProjects/RecommendedProjects';
// import ScenarioAnalysis from './FinancialProjections/Sections/ScenarioAnalysis/ScenarioAnalysis';
// import SolvingFor from './SolvingFor/SolvingFor';
// import Summary from './Summary/Summary';
import AddressHeader from './AddressHeader/AddressHeader';
import RiskOverview from './RiskOverview/RiskOverview';
import YourOptions from './YourOptions/YourOptions';
import TakingAction from './TakingAction/TakingAction';
import ProjectCard from '/src/Components/ProjectCard/ProjectCard';
import PersonalizeAnalysis from './PersonalizeAnalysis/PersonalizeAnalysis';
import FirstViewExplainer from './FirstViewExplainer/FirstViewExplainer';
import BigPicture from './BigPicture/BigPicture';

// IMPORT THE SERVICES
import { PropertyGaLoggingProvider } from '/src/contexts/PropertyGaLoggingContext';
import NormalizeDynamoDBItem from '/src/services/NormalizeDynamoDBItem';
import { decompressData } from '/src/utils/decompressData';
// import { CreateAccountPromptContext } from '../../PropertyExplorer';
// import { CreateGoogleMapsStreetviewUrl } from '/src/services/CreateGoogleMapsStreetviewUrl';
// import { fetchQGDData } from '/src/services/FetchGeoData';
import { fetchAllBoundaryData } from '/src/services/FetchAllBoundaryData';
import { QGDStorage, PortalStorage } from '/src/services/QGDStorage';
import RunQuollScoreAnalysis from '/src/services/QuollScore/RunQuollScoreAnalysis';
import CalculateAnonUserInfo from '/src/services/QuollScore/CalculateAnonUserInfo';
import ProcessMarketDataMaster from '/src/services/ProcessingHousingMkt/ProcessMarketDataMaster';
import { GALogEvent } from '/src/services/GoogleAnalytics/GALogEvent';
// EXPORT ICON
import ExportIcon from '/src/assets/export-icon.svg';

// Create context at the top of the file
export const AreaDataContext = createContext(null);

// import ExportModule from './OLD CODE/ExportModule/ExportModule';
import PropertyNavigation from './Navigation/PropertyNavigation';
import UpdateDataModule from './UpdateDataModule/UpdateDataModule';
import ProcessingSnackbar from './ProcessingSnackbar/ProcessingSnackbar';

const PropertyExplorer = () => {
    // const [areaData, setAreaData] = useState(null);
    // const [streetViewUrl, setStreetViewUrl] = useState(null);
    // const { handleShowCreateAccountPromptToggle } = useContext(CreateAccountPromptContext);
    // const [showExportModal, setShowExportModal] = useState(false);
    // const [formattedAddress, setFormattedAddress] = useState('');
    // const { portalData } = useContext(AddressSearchContext);

    const urlBaseline = {
        section: null,
        subsection: null
    }

    // Set the tab names (which will then be the url sections)
    const bigPictureTabName = 'big-picture';
    const riskOverviewTabName = 'risk-profile';
    const yourOptionsTabName = 'recommendations';
    const takingActionTabName = 'taking-action';
    const personalizeTabName = 'personalize';

    const { user, handleExplainerViewed, LOG_GA_EVENT } = useContext(AddressSearchContext);

    const hasUserViewedFirstPropertyExplorer = user?.firstPropertyExplorerViewed || false;

    const { testStatus } = useContext(TestStatusContext);
    const { setSkusDiscounts, addressSearchModelingTracker, setAddressSearchModelingTracker } = useContext(AddressSearchContext);
    const { deviceType } = useContext(WindowSizeContext);
    const [pageTitle, setPageTitle] = useState(null);
    const [propertyData, setPropertyData] = useState(null);
    const [activeTab, setActiveTab] = useState(bigPictureTabName);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [updateStatus, setUpdateStatus] = useState(false);
    const [showProcessingModal, setShowProcessingModal] = useState(false);
    const [processingComplete, setProcessingComplete] = useState(false);
    const [initialCheckComplete, setInitialCheckComplete] = useState(false);
    const [tapProjects, setTapProjects] = useState(null);
    const [selectedProject, setSelectedProject] = useState(null); // The project that is currently selected
    const [hasGeoData, setHasGeoData] = useState(false);
    const [geoData, setGeoData] = useState(null);
    const [contentLoaded, setContentLoaded] = useState(false);
    const [userPersonalInfoAnon, setUserPersonalInfoAnon] = useState(null);
    const [userPersonalInfo, setUserPersonalInfo] = useState(null);
    const [quollScoreAnalysis, setQuollScoreAnalysis] = useState(null);
    const [anonQuollScoreAnalysis, setAnonQuollScoreAnalysis] = useState(null);
    const [housingMarketData, setHousingMarketData] = useState(null);
    const [userPlans, setUserPlans] = useState([]);
    const [currentUrl, setCurrentUrl] = useState(urlBaseline);
    const [previousUrl, setPreviousUrl] = useState(urlBaseline);

    const [currentUrlSection, setCurrentUrlSection] = useState(null);
    const [previousUrlSection, setPreviousUrlSection] = useState(null);
    const [currentUrlSubsection, setCurrentUrlSubsection] = useState(null);
    const [previousUrlSubsection, setPreviousUrlSubsection] = useState(null);

    const [showFirstPropertyExplorerViewedExplainer, setShowFirstPropertyExplorerViewedExplainer] = useState(false);


    const navigate = useNavigate();
    const { id } = useParams();

    const PROPERTY_BASE_URL = `properties/${id}`

    const getPropertyDetailsForGALogging = (propertyData, geoDataInput = geoData) => {
        const propertyDetails = propertyData?.data?.property_details;
        const returnObject = {}


        const fipsGEOData = geoDataInput?.fips;
        const countyName = fipsGEOData?.county_name;

        returnObject.quoll_property_id = propertyData?.address_id;
        returnObject.quoll_property_city = propertyDetails?.city;
        returnObject.quoll_property_state_short = propertyDetails?.state_short;
        returnObject.quoll_property_state_long = propertyDetails?.state_long;
        returnObject.quoll_property_zip = propertyDetails?.zip;
        returnObject.quoll_property_fips = propertyDetails?.fips;
        returnObject.quoll_property_county_name = countyName;
        returnObject.quoll_property_census_tract = propertyDetails?.census_tract;

        return returnObject;
    }


    const handleLoggingGaEventFromProperty = (event, additionalParams = {}) => {


        // Get the property details for GA logging
        const propertyDetails = getPropertyDetailsForGALogging(propertyData, geoData);

        // Add the property details to the additional params
        additionalParams = { ...additionalParams, ...propertyDetails };

        LOG_GA_EVENT(event, additionalParams);
    }

    const handleUrlSectionChange = (section) => {
        if (section) {
            setPreviousUrlSection(currentUrlSection);
            setCurrentUrlSection(section);
        }
    }

    const handleUrlSubsectionChange = (subsection) => {
        if (subsection) {
            // console.log('SETTING THE SUBSECTION TO', subsection);
            setPreviousUrlSubsection(currentUrlSubsection);
            setCurrentUrlSubsection(subsection);
        }
    }

    const handleRevertToPreviousUrl = () => {
        if (previousUrlSection && previousUrlSubsection) {
            // navigate(`${previousUrlSection}/${previousUrlSubsection}`)  // relative
            setCurrentUrlSection(previousUrlSection);
            setCurrentUrlSubsection(previousUrlSubsection);
        }
    }
    const handleRevertToPreviousSubsectionUrl = () => {
        if (currentUrlSection && previousUrlSubsection) {
            // navigate(`${previousUrlSection}/${previousUrlSubsection}`)  // relative
            setCurrentUrlSubsection(previousUrlSubsection);
        }
    }

    const handleSectionChange = (type, section) => {

        if (type === 'subsection' || type === 'section') {
            setPreviousUrl(currentUrl);
        }


        if (type === 'subsection') {
            setCurrentUrl({
                section: currentUrl.section,
                subsection: section
            });
        } else if (type === 'section') {
            setCurrentUrl({
                section: section,
                subsection: null
            });
        }
    }

    // useEffect that on load does the first handleSectionChange
    useEffect(() => {
        handleSectionChange('section', activeTab);
        handleUrlSectionChange(activeTab);
    }, []);

    // useEffect that monitors activeTab and calls the handleSectionChange function
    useEffect(() => {
        if (activeTab) {
            // console.log('CURRENT ACTIVE TAB', activeTab);
            // console.log('SETTING THE SECTION TO', activeTab);
            handleSectionChange('section', activeTab);
            handleUrlSectionChange(activeTab);

            // Smooth scroll to the top of the page
            const contentElement = document.querySelector('.tab-content');
            // console.log('contentElement', contentElement);
            // console.log('contentElement.scrollTo', contentElement.scrollTo);
            // console.log('contentElement.scrollTo.top', contentElement.scrollTo.top);
            // console.log('contentElement.scrollTo.behavior', contentElement.scrollTo.behavior);
            // console.log('contentElement.scrollTo.top', contentElement.scrollTo.top);
            contentElement.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }, [activeTab]);

    // console.log('CURRENT URL', currentUrl);


    // useEffect that updates the currentUrl and previousUrl when the url changes
    // useEffect(() => {

    //     if (currentUrl && currentUrl.section && currentUrl.subsection) { 
    //         console.log('NAVIGATING TO', `${PROPERTY_BASE_URL}/${currentUrl.section}/${currentUrl.subsection}`);
    //         navigate(`${currentUrl.section}/${currentUrl.subsection}`)  // relative
    //     }
    // }, [currentUrl]);

    useEffect(() => {
        if (currentUrlSection && currentUrlSubsection && currentUrlSection !== bigPictureTabName) {
            // console.log('NAVIGATING TO', `${PROPERTY_BASE_URL}/${currentUrlSection}/${currentUrlSubsection}`);
            navigate(`${currentUrlSection}/${currentUrlSubsection}`)  // relative
        } else if (currentUrlSection && currentUrlSection === bigPictureTabName) {
            navigate(`${currentUrlSection}`)  // relative
        }
    }, [currentUrlSection, currentUrlSubsection]);

    // Function to check local storage for the qgd data for this property
    const checkLocalStorageForQGDData = async (propertyData) => {
        const { zip, fips, state_short, census_tract } = propertyData.data.property_details;

        try {
            const dbReturn = await Promise.all([
                QGDStorage.getData('zip', zip),
                QGDStorage.getData('fips', fips),
                QGDStorage.getData('state', state_short),
                QGDStorage.getData('census_tract', census_tract)
            ]);

            const [zipData, fipsData, stateData, censusData] = dbReturn;

            if (zipData && fipsData && stateData && censusData) {
                setGeoData({
                    zip: zipData,
                    fips: fipsData,
                    state: stateData,
                    census_tract: censusData
                });
                setHasGeoData(true);
                return true;
            } else {
                setHasGeoData(false);
                setGeoData(null);
                return false;
            }
        } catch (error) {
            console.error('Error checking IndexedDB data:', error);
            return false;
        }
    }

    // Function to check local storage for the skus and discounts this property needs
    const checkLocalStorageForSkusAndDiscounts = async (propertyData) => {
        // Get current data from IndexedDB
        const stored_skus = await PortalStorage.getDatapoint('skus') || [];
        const stored_discounts = await PortalStorage.getDatapoint('discounts') || [];

        try {
            // console.log('Checking local storage for skus and discounts');
            // Get the lists from property data
            const skus_id_list = propertyData?.data?.recommended_projects?.sku_ids_list;
            const discounts_id_list = propertyData?.data?.recommended_projects?.master_discounts;


            // Find missing items
            const missing_skus = skus_id_list.filter(id =>
                !stored_skus.some(sku => sku.product_id === id)
            );
            const missing_discounts = discounts_id_list.filter(id =>
                !stored_discounts.some(discount => discount.id === id)
            );

            // If we have missing items, fetch them
            if (missing_skus.length > 0 || missing_discounts.length > 0) {
                console.log('Fetching missing SKUs and discounts FROM API');
                const response = await axios.post(
                    `${import.meta.env.VITE_API_BASE_URL}/get-discounts-skus`,
                    {
                        skus: missing_skus,
                        discounts: missing_discounts
                    }
                );

                let updated_skus = stored_skus;
                let updated_discounts = stored_discounts;

                // Merge new items with existing ones
                if (response.data.skus?.length > 0) {
                    updated_skus = [...stored_skus, ...response.data.skus];
                    // Save to IndexedDB asynchronously
                    PortalStorage.setDatapoint('skus', updated_skus).catch(error => {
                        console.error('Failed to save SKUs to IndexedDB:', error);
                    });
                }

                if (response.data.discounts?.length > 0) {
                    updated_discounts = [...stored_discounts, ...response.data.discounts];
                    // Save to IndexedDB asynchronously
                    PortalStorage.setDatapoint('discounts', updated_discounts).catch(error => {
                        console.error('Failed to save discounts to IndexedDB:', error);
                    });
                }

                // Update the context immediately
                setSkusDiscounts({
                    skus: updated_skus,
                    discounts: updated_discounts
                });
            } else {
                // If no missing items, just update context with stored data
                setSkusDiscounts({
                    skus: stored_skus,
                    discounts: stored_discounts
                });
            }
        } catch (error) {
            console.error('Error handling SKUs and discounts:', error);
            // Still update context with whatever we have
            // const stored_skus = await PortalStorage.getDatapoint('skus') || [];
            // const stored_discounts = await PortalStorage.getDatapoint('discounts') || [];
            setSkusDiscounts({
                skus: stored_skus,
                discounts: stored_discounts
            });
        }
    };

    // First useEffect - check local storage
    useEffect(() => {
        async function initializeProperty(paramId) {
            const storedUser = localStorage.getItem('user');
            if (!storedUser) {
                navigate('/');
                return;
            }
            // console.log("USE EFFECT CALLED TO CHECK LOCAL STORAGE FOR USER DATA")
            const userData = JSON.parse(storedUser);
            const property = userData.addresses?.find(
                addr => addr.address_id === paramId
            );

            if (property) {
                const hasGeoData = await checkLocalStorageForQGDData(property);
                // console.log("HAS GEO DATA:", hasGeoData)
                if (!hasGeoData) {
                    setHasGeoData(false);
                }
                checkLocalStorageForSkusAndDiscounts(property);
                setPropertyData(property);
                setActiveTab(bigPictureTabName);

                // Make sure addressSearchModelingTrackerInitialState searchInProgress is set to false
                setAddressSearchModelingTracker({
                    ...addressSearchModelingTracker,
                    searchInProgress: false
                });

                LOG_GA_EVENT('property_view_return_in_session', getPropertyDetailsForGALogging(property));

            } else {
                // If the setAddressSearchModelingTracker searchInProgress is set to false it means they came to this url directly so then we need to trigger the search logic
                if (!addressSearchModelingTracker.searchInProgress) {

                    setAddressSearchModelingTracker(prevState => ({
                        ...prevState,
                        searchInProgress: true,
                        searchType: 'url',
                        quollPropertyId: paramId
                    }));
                }
            }

            setInitialCheckComplete(true);
        }
        // console.log('INITIALIZING PROPERTY WITH ID', id);
        initializeProperty(id);
    }, [id]);
    // }, [id, navigate]);

    // Second useEffect - fetch data if needed
    useEffect(() => {
        const fetchPropertyData = async () => {

            // console.log('IN THE SECOND USE EFFECT FOR FETCHING PROPERTY DATA', (!initialCheckComplete || !propertyData || propertyData?.data));

            // if (!initialCheckComplete || !propertyData || propertyData?.data) {
            if (!initialCheckComplete || addressSearchModelingTracker.processStage !== 'modeling') {
                // console.log('IN THE SECOND USE EFFECT FOR FETCHING PROPERTY DATA --> FAILED INITIAL CHECK');
                return;
            }
            // console.log('IN THE SECOND USE EFFECT FOR FETCHING PROPERTY DATA --> PASSED INITIAL CHECK');

            try {

                const userId = user?.user_id || null;
                const userSessionId = user?.sessionId || null;

                let userIdToUse = userId || userSessionId || 'Quoll';

                // console.log('Fetching property data from Property Explorer WITHIN THE TRY');
                const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

                const response = await axios.post(
                    `${apiBaseUrl}/process-property`,
                    {
                        address_id: id,
                        customer_id: userIdToUse
                    }
                );

                // console.log('RESPONSE FROM THE API', response);

                if (response.data.outcome === 'PASS' && response.data.data) {
                    // console.log('GOT THE DATA FROM THE API WITHIN THE TRY', response.data);
                    // Get the property change log and normalize it
                    const propertyChangeLog = response.data.change_log ?
                        NormalizeDynamoDBItem(response.data.change_log) :
                        [];

                    const parsedData = decompressData(response.data.data);

                    const google_place_id = parsedData?.google_place_id || null;

                    const parsedDataPropertyInfo = parsedData.property_details;

                    // console.log('PARSED DATA', parsedData);

                    const user = JSON.parse(localStorage.getItem('user'));
                    if (!user.addresses) {
                        user.addresses = [];
                    }

                    const { googlePlaceId, quollPropertyId } = addressSearchModelingTracker

                    const newPropertyData = {
                        address_id: id,
                        place_id: google_place_id,
                        data: parsedData,
                        change_log: propertyChangeLog,
                        last_search: new Date().toISOString()
                    }

                    // Check if address already exists
                    const addressExists = user.addresses.some(addr => addr.address_id === quollPropertyId);
                    if (!addressExists) {
                        user.addresses.push(newPropertyData);
                        localStorage.setItem('user', JSON.stringify(user));
                    }
                    // console.log('DATA FROM THE API HAS BEEN ADDED TO LOCAL STORAGE');
                    checkLocalStorageForSkusAndDiscounts(newPropertyData);
                    const hasGeoData = await checkLocalStorageForQGDData(newPropertyData);
                    // console.log("HAS GEO DATA:", hasGeoData)
                    if (!hasGeoData) {
                        setHasGeoData(false);
                    }
                    setPropertyData(newPropertyData);
                    // console.log('PROPERTY DATA HAS BEEN SET TO:', newPropertyData);
                    setActiveTab(bigPictureTabName);

                    // Set searchInProgress to false
                    setAddressSearchModelingTracker({
                        ...addressSearchModelingTracker,
                        searchInProgress: false
                    });

                    LOG_GA_EVENT('property_view_first_time_in_session', getPropertyDetailsForGALogging(newPropertyData));


                } else {
                    navigate('/');
                }

            } catch (error) {
                console.error('Error fetching property data:', error);
                if (error.response) {
                    console.error('Error response:', error.response.data);
                }
                navigate('/');
            }
        };
        if (addressSearchModelingTracker.searchInProgress === true && addressSearchModelingTracker.processStage === 'modeling' && initialCheckComplete) {
            // console.log("RUNNING FETCH PROPERTY DATA AFTER INITIAL CHECK", addressSearchModelingTracker, initialCheckComplete);
            fetchPropertyData();
        }
    }, [addressSearchModelingTracker, initialCheckComplete]);
    // }, [propertyData, initialCheckComplete]);

    // useEffect that on initial load / propertyData changes checks local storage for the user and sets the state for userPersonalInfo
    useEffect(() => {
        const userPersonalInfoLocal = JSON.parse(localStorage.getItem('user'));
        if (!userPersonalInfoLocal) return;

        const userFinances = userPersonalInfoLocal.finances || {};

        // console.log('userFinances on load', userFinances);

        const userFinancesHouseholdIncome = userFinances.householdIncome || null;
        const userFinancesAvailableFunds = userFinances.availableFunds || null;
        const userFinancesRelationToPropertyList = userFinances.propertyRelations || [];

        let userFinancesRelationToThisSpecificProperty = null;
        let userFinancesRelationToThisSpecificPropertyMonthlyMortgagePayment = null;
        let userFinancesRelationToThisSpecificPropertyExpectedPurchasePrice = null;

        if (propertyData) {
            const userFinancesRelationToThisSpecificPropertyObject = userFinancesRelationToPropertyList.find(relation => relation.address_id === propertyData.address_id);
            userFinancesRelationToThisSpecificProperty = userFinancesRelationToThisSpecificPropertyObject?.relation_to_property || null;
            userFinancesRelationToThisSpecificPropertyMonthlyMortgagePayment = userFinancesRelationToThisSpecificPropertyObject?.monthly_mortgage_payment || null;
            userFinancesRelationToThisSpecificPropertyExpectedPurchasePrice = userFinancesRelationToThisSpecificPropertyObject?.expected_purchase_price || null;

        }

        let isUserPersonalInfoComplete = false;
        if (userFinancesHouseholdIncome && userFinancesAvailableFunds && userFinancesRelationToThisSpecificProperty) {

            if (userFinancesRelationToThisSpecificProperty === "buyer") {
                if (userFinancesRelationToThisSpecificPropertyExpectedPurchasePrice) {
                    isUserPersonalInfoComplete = true;
                }
            } else if (userFinancesRelationToThisSpecificProperty === "owner") {
                if (userFinancesRelationToThisSpecificPropertyMonthlyMortgagePayment) {
                    isUserPersonalInfoComplete = true;
                }
            }
        }
        // console.log("Is User Personal Info Complete", isUserPersonalInfoComplete, userFinancesHouseholdIncome, userFinancesAvailableFunds, userFinancesRelationToThisSpecificProperty);

        const userPersonalInfo = {
            householdIncome: userFinancesHouseholdIncome,
            availableFunds: userFinancesAvailableFunds,
            relationToProperty: userFinancesRelationToThisSpecificProperty,
            monthlyMortgagePayment: userFinancesRelationToThisSpecificPropertyMonthlyMortgagePayment,
            expectedPurchasePrice: userFinancesRelationToThisSpecificPropertyExpectedPurchasePrice,
            isComplete: isUserPersonalInfoComplete
        }

        if (propertyData) {
            setUserPersonalInfo(userPersonalInfo);
            if (isUserPersonalInfoComplete) {
                const quollScoreAnalysis = RunQuollScoreAnalysis(propertyData, userPersonalInfo);
                setQuollScoreAnalysis(quollScoreAnalysis);
            }
        }
    }, [propertyData]);

    // useEffect that listens for changes to userPersonalInfo and updates local storage for the user
    useEffect(() => {
        if (!userPersonalInfo || !propertyData) return;

        // Get the current user from local storage
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) return;

        // Pull the pieces from the userPersonalInfo object
        const userFinancesHouseholdIncome = userPersonalInfo?.householdIncome || null;
        const userFinancesAvailableFunds = userPersonalInfo?.availableFunds || null;
        const userFinancesRelationToProperty = userPersonalInfo?.relationToProperty || null;
        const userFinancesMonthlyMortgagePayment = userPersonalInfo?.monthlyMortgagePayment || null;
        const userFinancesExpectedPurchasePrice = userPersonalInfo?.expectedPurchasePrice || null;
        const userFinancesIsComplete = userPersonalInfo?.isComplete || false;

        // console.log("Information before determining if the user personal info is complete", userFinancesHouseholdIncome, userFinancesAvailableFunds, userFinancesRelationToProperty, userFinancesMonthlyMortgagePayment, userFinancesExpectedPurchasePrice, userFinancesIsComplete);

        // Determine if we have the complete set of data to run the quoll score analysis
        let isUserPersonalInfoComplete = false;
        if (userFinancesHouseholdIncome && userFinancesAvailableFunds && userFinancesRelationToProperty) {
            if (userFinancesRelationToProperty === "buyer") {
                if (userFinancesExpectedPurchasePrice) {
                    isUserPersonalInfoComplete = true;
                }
            } else if (userFinancesRelationToProperty === "owner") {
                if (userFinancesMonthlyMortgagePayment) {
                    isUserPersonalInfoComplete = true;
                }
            }
        }

        // If we have all of the pieces then run the quoll score analysis
        if (userFinancesIsComplete) {
            const quollScoreAnalysis = RunQuollScoreAnalysis(propertyData, userPersonalInfo);
            setQuollScoreAnalysis(quollScoreAnalysis);
        }

        // If user does not have a finances object, create one
        if (!user.finances) {
            // console.log('NO FINANCES OBJECT FOUND, CREATING ONE');
            // console.log('user at that moment', user);
            user.finances = {
                householdIncome: null,
                availableFunds: null,
                propertyRelations: []
            };
        }

        // Update the user directly for income and funds
        user.finances.householdIncome = userFinancesHouseholdIncome;
        user.finances.availableFunds = userFinancesAvailableFunds;

        // Add a new object (or update the existing one) to the relation_to_property array (asumming there is a propertyData object)
        if (propertyData) {
            const existingRelation = user.finances.propertyRelations.find(relation => relation.address_id === propertyData.address_id);
            // console.log('existingRelation', existingRelation);
            // console.log('new relation', userFinancesRelationToProperty);
            if (existingRelation) {
                existingRelation.relation_to_property = userFinancesRelationToProperty;
                existingRelation.monthly_mortgage_payment = userFinancesMonthlyMortgagePayment;
                existingRelation.expected_purchase_price = userFinancesExpectedPurchasePrice;
            } else {
                user.finances.propertyRelations.push({
                    address_id: propertyData.address_id,
                    relation_to_property: userFinancesRelationToProperty,
                    monthly_mortgage_payment: userFinancesMonthlyMortgagePayment,
                    expected_purchase_price: userFinancesExpectedPurchasePrice
                });
            }
        }

        // Update local storage with the new user
        localStorage.setItem('user', JSON.stringify(user));
    }, [userPersonalInfo, propertyData]);

    // useEffect that runs the quoll score analysis when the userPersonalInfo, propertyData, and geoData are set
    useEffect(() => {
        if (userPersonalInfo && propertyData && geoData && housingMarketData) {

            // Pull the pieces from the userPersonalInfo object
            const userFinancesHouseholdIncome = userPersonalInfo?.householdIncome || null;
            const userFinancesAvailableFunds = userPersonalInfo?.availableFunds || null;
            const userFinancesRelationToProperty = userPersonalInfo?.relationToProperty || null;
            const userFinancesIsComplete = userPersonalInfo?.isComplete || false;
            // If we have all of the pieces then run the quoll score analysis
            if (userFinancesIsComplete) {
                const quollScoreAnalysis = RunQuollScoreAnalysis(propertyData, userPersonalInfo, geoData, housingMarketData);
                setQuollScoreAnalysis(quollScoreAnalysis);
            } else {
                // Set quollScoreAnalysis to null if it is not currently non-null
                if (quollScoreAnalysis) {
                    setQuollScoreAnalysis(null);
                }
                const anonUserInfo = CalculateAnonUserInfo(propertyData, geoData, housingMarketData);
                setUserPersonalInfoAnon(anonUserInfo);
                const anonQuollScoreAnalysis = RunQuollScoreAnalysis(propertyData, anonUserInfo, geoData, housingMarketData);
                setAnonQuollScoreAnalysis(anonQuollScoreAnalysis);
            }
        }
    }, [userPersonalInfo, propertyData, geoData, housingMarketData]);

    // useEffect that processes the housing market data when propertyData and geoData are set
    useEffect(() => {
        if (propertyData && geoData) {

            // console.log('In the useEffect for processing the housing market data', propertyData, geoData);
            const housingMarketData = ProcessMarketDataMaster(propertyData, geoData);
            // console.log('Output of the useEffect for processing the housing market data', housingMarketData);
            setHousingMarketData(housingMarketData);

            // Set the showFirstPropertyExplorerViewedExplainer to true (we'll check if they have already seen it in the return)
            setShowFirstPropertyExplorerViewedExplainerToTrue();
        }
    }, [propertyData, geoData]);

    // Handler for waiting 3 seconds then setting showFirstPropertyExplorerViewedExplainer to false
    const setShowFirstPropertyExplorerViewedExplainerToTrue = () => {
        setTimeout(() => {
            setShowFirstPropertyExplorerViewedExplainer(true);
        }, 2000);
    }

    // When propertyData is set, create the streetViewUrl
    useEffect(() => {
        if (propertyData) {
            // console.log('Property Data:', propertyData);
            // const lat = propertyData.data.property_details.lat;
            // const long = propertyData.data.property_details.long;
            // setStreetViewUrl(CreateGoogleMapsStreetviewUrl(lat, long));

            // Add null check for data and property_details
            if (propertyData.data && propertyData.data.property_details) {
                const street = propertyData.data.property_details.street;
                const cityState = propertyData.data.property_details.city_state;
                setPageTitle(`${street}, ${cityState}`);
            }

            // Load 'tap' (taking action projects) data from local storage and parse it
            const tapData = localStorage.getItem('tap');
            const tapDataJson = JSON.parse(tapData) || {};

            // Get the set for this address from tapDataJson, or create an empty set if it doesn't exist
            const tapSet = new Set(tapDataJson[addressId] || []);
            setTapProjects(tapSet);
        }
    }, [propertyData]);

    const property_id = propertyData?.address_id || null;
    const customizable_properties = ["aUkAXtIDohcwMw", "jMXriBsn1xVn2g"]

    useEffect(() => {

        if (propertyData) {
            const fetchGeoData = async () => {
                if (propertyData && !hasGeoData) {
                    console.log("USE EFFECT CALLED TO FETCH GEO DATA", propertyData);
                    const fetchInput = {
                        zip_code: propertyData.data.property_details.zip,
                        fips: propertyData.data.property_details.fips,
                        state_short_name: propertyData.data.property_details.state_short,
                        census_tract: propertyData.data.property_details.census_tract
                    }
                    await fetchAllBoundaryData(fetchInput);
                    setHasGeoData(true);
                }
            }
            fetchGeoData();
        }
    }, [propertyData]);


    // useEffect that tracks hasGeoData and if true and there is a property then it loads the geoData from the indexedDB
    useEffect(() => {
        // console.log('IN THE NEW USE EFFECT FOR GEO DATA');
        if (hasGeoData && propertyData && !geoData) {
            // console.log('WITHIN THE IF STATEMENT');
            const { zip, fips, state_short, census_tract } = propertyData.data.property_details;

            async function loadData() {
                const [indexedZipData, indexedFipsData, indexedStateData, indexedCensusTractData] = await Promise.all([
                    QGDStorage.getData('zip', zip),
                    QGDStorage.getData('fips', fips),
                    QGDStorage.getData('state', state_short),
                    QGDStorage.getData('census_tract', census_tract)
                ]);
                setGeoData({
                    zip: indexedZipData,
                    fips: indexedFipsData,
                    state: indexedStateData,
                    census_tract: indexedCensusTractData
                });
            }
            loadData();
        }
    }, [hasGeoData, propertyData, geoData]);


    // useEffect that sets contentLoaded to true when geoData, propertyData, and hasGeoData are all true
    useEffect(() => {
        if (geoData && propertyData && hasGeoData) {
            setContentLoaded(true);
        }
    }, [geoData, propertyData, hasGeoData]);

    // useEffect that listens for processingComplete and if showProcessingModal is true then it sets showProcessingModal to false
    useEffect(() => {
        if (processingComplete && showProcessingModal) {
            setShowProcessingModal(false);
        }
    }, [processingComplete, showProcessingModal]);

    const customization_info = !!propertyData?.data?.user_input_form
    const addressId = propertyData?.address_id || null;

    // Create a handler function that takes in either a project id or array of ids
    const handleUserAddingTapProjectId = (projectIdInput) => {
        // Convert input to array if it's not already
        const projectIds = Array.isArray(projectIdInput) ? projectIdInput : [projectIdInput];

        // Log the event
        const gaAdditionalParams = {
            projectIds: projectIds,
        }
        handleLoggingGaEventFromProperty('recommendations_project_added_to_lab', gaAdditionalParams);

        setTapProjects(prev => {
            const newSet = new Set(prev);
            projectIds.forEach(id => newSet.add(id));

            // Get current tap data from localStorage
            const currentTapData = JSON.parse(localStorage.getItem('tap')) || {};

            // Update the set for this addressId while preserving other addresses
            currentTapData[addressId] = [...newSet];

            // Save back to localStorage
            localStorage.setItem('tap', JSON.stringify(currentTapData));

            return newSet;
        });
    }

    // Create a handler function that takes in either a project id or array of ids
    const handleUserRemovingTapProjectId = (projectIdInput) => {
        // Convert input to array if it's not already
        const projectIds = Array.isArray(projectIdInput) ? projectIdInput : [projectIdInput];

        setTapProjects(prev => {
            const newSet = new Set(prev);
            projectIds.forEach(id => newSet.delete(id));

            // Get current tap data from localStorage
            const currentTapData = JSON.parse(localStorage.getItem('tap')) || {};

            // Update the set for this addressId while preserving other addresses
            currentTapData[addressId] = [...newSet];

            // Save back to localStorage
            localStorage.setItem('tap', JSON.stringify(currentTapData));

            return newSet;
        });
    }

    // Create a handler that sends user to the riskOverview page
    const goToRiskOverview = () => {
        setActiveTab(riskOverviewTabName);
    }

    // Create handler that sends user to the Taking Action page
    const goToTakingAction = () => {
        setActiveTab(takingActionTabName);
    }

    // Create handler that sends user to the Your Options page
    const goToYourOptions = () => {
        setActiveTab(yourOptionsTabName);
    }

    // Create handler that sends user to the Personalize Analysis page
    const goToPersonalizeAnalysis = () => {
        setActiveTab(personalizeTabName);
    }

    // Create a handler that updates the selected project when a new project is clicked (or to null if the same project is clicked again)
    const handleProjectClick = (projectId) => {


        // Get the project from the selectedArea.projects_list array
        const project = refinedProjectsList.find(project => project.project_id === projectId);

        // If selectedProject.id is not the same as projectId, set the selected project to the project
        if (selectedProject?.id !== projectId) {
            setSelectedProject(project);
            // const gaAdditionalParams = {
            //     projectId,
            //     projectName: project.project_name,
            // }
            // LOG_GA_EVENT('project_opened', gaAdditionalParams);
        }
        // If selectedProject.id is the same as projectId, set the selected project to null
        else {
            setSelectedProject(null);
        }
    };

    // Create a handler that sets the selected project to null when the close button is clicked or clicked outside of the project card
    const handleCloseProjectClick = () => {
        setSelectedProject(null);
        handleRevertToPreviousUrl();
        handleRevertToPreviousSubsectionUrl();
    }

    // useEffect that when activeTab changes, if it is set to 'customize' then set showUpdateModal to true
    // useEffect(() => {
    //     if (activeTab === 'customize') {
    //         setShowUpdateModal(true);
    //     }
    // }, [activeTab]);

    const handleTabChange = (tabId) => {
        // if (tabId === 'personalize') {
        //     setShowUpdateModal(true);
        // }

        setActiveTab(tabId);

        // Smooth scroll to the top of the page
        document.querySelector('.content-wrapper').scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    const handleCreatePlanFromLabComplete = (newPlan) => {
        setActiveTab(takingActionTabName);

        // Load 'wim' from local storage and change to empty array for the addressId
        const wim = JSON.parse(localStorage.getItem('wim')) || {};
        wim[addressId] = [];
        localStorage.setItem('wim', JSON.stringify(wim));
    }

    const handleFirstPropertyExplorerViewed = () => {
        setShowFirstPropertyExplorerViewedExplainer(false);
        LOG_GA_EVENT('first_property_view');
        handleExplainerViewed('firstPropertyExplorerViewed');
    }

    // useEffect to handle url changes when a project is clicked
    useEffect(() => {
        if (selectedProject) {
            const selectedProjectId = selectedProject.project_id || 999;
            const newSection = `projects/${selectedProjectId}`;
            handleUrlSectionChange(newSection);
        }
    }, [selectedProject]);


    return (
        <>
            {pageTitle &&
                <HelmetProvider
                    pageType="property"
                    pageId={pageTitle}
                />
            }
            <PropertyGaLoggingProvider value={{
                handleLoggingGaEventFromProperty
            }}>

                <AreaDataContext.Provider value={{
                    // areaData,
                    tapProjects,
                    handleUserAddingTapProjectId,
                    handleUserRemovingTapProjectId,
                    goToRiskOverview,
                    goToTakingAction,
                    goToYourOptions,
                    selectedProject,
                    setSelectedProject,
                    geoData,
                    contentLoaded,
                    handleProjectClick,
                    userPersonalInfo,
                    setUserPersonalInfo,
                    userPersonalInfoAnon,
                    setUserPersonalInfoAnon,
                    quollScoreAnalysis,
                    anonQuollScoreAnalysis,
                    housingMarketData,
                    userPlans,
                    setUserPlans,
                    handleCreatePlanFromLabComplete,
                    handleSectionChange,
                    handleUrlSectionChange,
                    handleUrlSubsectionChange,
                    handleRevertToPreviousUrl,
                    handleRevertToPreviousSubsectionUrl,
                }}>
                    <div className={`main-content report ${deviceType === 'mobile' ? 'mobile' : ''}`}>

                        {/* SELECTED PROJECT CARD */}
                        {selectedProject && (
                            <ProjectCard
                                propertyData={propertyData}
                                project={selectedProject}
                                onClose={handleCloseProjectClick}
                                handleUrlSubsectionChange={handleUrlSubsectionChange}
                            />
                        )}

                        {/* UPDATE DATA MODAL */}
                        {showUpdateModal && (
                            <UpdateDataModule
                                propertyData={propertyData}
                                setShowUpdateModal={setShowUpdateModal}
                                setPropertyData={setPropertyData}
                                setUpdateStatus={setUpdateStatus}
                                setShowProcessingModal={setShowProcessingModal}
                                setProcessingComplete={setProcessingComplete}
                            />
                        )}
                        {showProcessingModal && (
                            <ProcessingSnackbar
                                show={showProcessingModal}
                                setShowProcessingModal={setShowProcessingModal}
                                processingComplete={processingComplete}
                                setProcessingComplete={setProcessingComplete}
                            />
                        )}

                        {/* FIRST PROPERTY EXPLORER VIEWED EXPLAINER */}
                        {(showFirstPropertyExplorerViewedExplainer && !hasUserViewedFirstPropertyExplorer) && (
                            <FirstViewExplainer
                                handleOutsideClick={handleFirstPropertyExplorerViewed}
                            />
                        )}

                        {/* Navigation Tabs */}
                        <>
                            <AddressHeader
                                propertyData={propertyData}
                                goToPersonalizeAnalysis={goToPersonalizeAnalysis}
                                activeTab={activeTab}
                            />
                            <PropertyNavigation
                                isContentLoaded={propertyData !== null}
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                handleTabChange={handleTabChange}
                            />

                            <div className="property-details">
                                {/* If propertyData is not null, render the tab content */}
                                <div className={`tab-content ${deviceType}`}>

                                    {activeTab === riskOverviewTabName && <RiskOverview propertyData={propertyData} />}
                                    {([yourOptionsTabName, takingActionTabName, personalizeTabName, bigPictureTabName].includes(activeTab)) && (
                                        propertyData ? (
                                            <>
                                                {activeTab === bigPictureTabName && <BigPicture propertyData={propertyData} />}
                                                {activeTab === yourOptionsTabName && <YourOptions propertyData={propertyData} />}
                                                {activeTab === takingActionTabName && <TakingAction propertyData={propertyData} />}
                                                {activeTab === personalizeTabName && <PersonalizeAnalysis propertyData={propertyData} setShowUpdateModal={setShowUpdateModal} setShowProcessingModal={setShowProcessingModal} setUpdateStatus={setUpdateStatus} setProcessingComplete={setProcessingComplete} setPropertyData={setPropertyData} goToRiskOverview={goToRiskOverview} />}
                                            </>
                                        ) : (
                                            <div className="loading-state">
                                                <h2 className="tab-title">Loading property data...</h2>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        </>
                    </div>
                </AreaDataContext.Provider >
            </PropertyGaLoggingProvider>
        </>
    );
};

export default PropertyExplorer; 